import { apiContextRawFetch, type ApiContext } from "@/hooks/api/base"

export type BeneficiaryReportFormat = "pdf" | "png"
export type BeneficiaryReportSize = "letter" | "square" | "widescreen"

export interface BeneficiaryReportOptions {
  clientId: string
  accountIds: string[]
  format: BeneficiaryReportFormat
  size: BeneficiaryReportSize
}

export async function downloadBeneficiaryReport(context: ApiContext, options: BeneficiaryReportOptions) {
  const params = new URLSearchParams({ output_format: options.format, size: options.size })
  options.accountIds.forEach((id) => params.append("account_ids[]", id))
  const response = await apiContextRawFetch(context, `clients/${options.clientId}/beneficiary_report?${params}`)
  const filename = response.headers.get("Content-Disposition")?.match(/filename="([^"]+)"/)?.[1]
  if (!filename) throw new Error("The report download filename is missing")
  return { blob: await response.blob(), filename }
}
